import paths from '@src/paths';

const navItems = [
  {
    key: 'performance',
    title: 'Performance',
    items: [
      { key: 'dailyPulse', title: 'Client Pulse', href: paths.dashboard.dailyPulse, icon: 'calendar-check' },
      { key: 'dataHealth', title: 'Data Health', href: paths.dashboard.dataHealth, icon: 'heartbeat' },
      { key: 'performanceTrends', title: 'Performance Trends', href: paths.dashboard.performanceTrends, icon: 'pulse' },
      { key: 'companyPerformance', title: 'Company Performance', href: paths.dashboard.companyPerformance, icon: 'table' },
      { key: 'genderPerformance', title: 'Gender Performance', href: paths.dashboard.genderPerformance, icon: 'table' },
      { key: 'placementPerformance', title: 'Placement Performance', href: paths.dashboard.placementPerformance, icon: 'table' },
      { key: 'dayOfWeekPerformance', title: 'Day of Week Performance', href: paths.dashboard.dayOfWeekPerformance, icon: 'table' },
      { key: 'leadRevenueBenchmark', title: 'Lead Revenue (Predicted vs Realized)', href: paths.leadRevenueBenchmark, icon: 'trend-up' },
      { key: 'clientPerformanceAggregator', title: 'Creative Performance (Internal)', href: paths.dashboard.clientPerformanceAggregator, icon: 'table' },
      { key: 'designerCreativePerformance', title: 'Designer Creative Performance', href: paths.dashboard.designerCreativePerformance, icon: 'table' },
      { key: 'adPerformance', title: 'Creative Performance', href: paths.dashboard.adPerformance, icon: 'image' },
    ],
  },
  {
    key: 'clients',
    title: 'Clients',
    items: [
      { key: 'clientList', title: 'Clients', href: paths.clients, icon: 'users' },
      { key: 'clientCreate', title: 'New Client', href: paths.clientCreate, icon: 'plus-circle' },
      { key: 'onboardingFlow', title: 'Onboarding', href: paths.onboarding.list, icon: 'list-checks' },
      { key: 'prospects', title: 'Prospects', href: paths.prospects, icon: 'user-plus' },
      { key: 'clientInvites', title: 'Invite Members', href: paths.clientInvites, icon: 'envelope-simple' },
      { key: 'clientOffers', title: 'Client Offers', href: paths.clientOffers, icon: 'receipt' },
    ],
  },
  {
    key: 'targetingBudget',
    title: 'Targeting & Budget',
    items: [
      { key: 'clientZips', title: 'Client Zips', href: paths.clientZips, icon: 'map-pin' },
      { key: 'zipCoverage', title: 'ZIP Coverage', href: paths.zipCoverage, icon: 'map-pin' },
      { key: 'zipSubmissions', title: 'ZIP Submissions', href: '/clients/zip-submissions', icon: 'clipboard-check' },
      { key: 'clientLanes', title: 'Client Lanes', href: paths.clientLanes, icon: 'table' },
      { key: 'clientBudgets', title: 'Client Budgets', href: paths.clientBudgets, icon: 'trend-up' },
      { key: 'budgetCenter', title: 'Budget Center', href: paths.budgetCenter, icon: 'table' },
      { key: 'forecast', title: 'Forecast', href: paths.forecast, icon: 'trend-up' },
      { key: 'budgetSubmissions', title: 'Budget Submissions', href: paths.budgetSubmissions, icon: 'clipboard-check' },
      { key: 'budgetOptimizer', title: 'Budget Optimizer', href: paths.facebook.budgetOptimizer, icon: 'trend-up' },
      { key: 'zipTargetingAnalyzer', title: 'ZIP Targeting Analyzer', href: paths.zipTargetingAnalyzer, icon: 'sparkle' },
      { key: 'activePacingHolds', title: 'Active Holds (All Clients)', href: paths.activePacingHolds, icon: 'list-checks' },
      { key: 'campaignBuilder', title: 'Campaign Builder', href: paths.facebook.campaignBuilder, icon: 'share-network' },
      { key: 'localAdBuilder', title: 'Local Ad Builder', href: paths.facebook.localAdBuilder, icon: 'share-network' },
      { key: 'facebookPages', title: 'Facebook Pages', href: paths.facebook.pages, icon: 'share-network' },
    ],
  },
  {
    key: 'leadsData',
    title: 'Leads & Data',
    items: [
      {
        key: 'leads',
        title: 'Leads',
        icon: 'user-focus',
        items: [
          { key: 'leadsList', title: 'List Leads', href: paths.leads.list },
        ],
      },
      { key: 'leadDelivery', title: 'Lead Delivery', href: '/lead-delivery', icon: 'plugs-connected' },
      {
        key: 'backendData',
        title: 'Backend Data',
        icon: 'table',
        items: [
          { key: 'backendDataList', title: 'List Records', href: paths.backendData.list },
          { key: 'backendDatasummary', title: 'Summary', href: paths.backendData.summary },
        ],
      },
      { key: 'dataIntegrations', title: 'Data Integrations', href: paths.dataIntegrations.health, icon: 'link-simple' },
      { key: 'emailMappings', title: 'Backend Mappings', href: paths.emailMappings, icon: 'link-simple' },
      { key: 'customReports', title: 'Custom Reports', href: paths.customReports, icon: 'table' },
      { key: 'dataBackfill', title: 'Data Backfill', href: paths.dashboard.dataBackfill, icon: 'calendar-check' },
    ],
  },
  {
    key: 'creative',
    title: 'Creative & Ads',
    items: [
      { key: 'creativeTasks', title: 'Creative Flights', href: paths.creativeTasks, icon: 'airplane' },
      { key: 'clientCreativeKnowledge', title: 'Creative Knowledge', href: paths.clientCreativeKnowledge, icon: 'book-open-text' },
      { key: 'creativeStudio', title: 'Creative Studio', href: paths.creativeStudio, icon: 'film-slate' },
      { key: 'designerBank', title: 'Designer Bank', href: paths.designerBank, icon: 'receipt' },
      { key: 'conceptSystem', title: 'Creative Engine', href: paths.conceptSystem, icon: 'graph' },
      { key: 'adNameBuilder', title: 'Ad Name Builder', href: paths.adBuilder, icon: 'file' },
    ],
  },
  {
    key: 'communications',
    title: 'Communications',
    items: [
      { key: 'clientInbox', title: 'Client Inbox', href: paths.clientInbox, icon: 'envelope-simple' },
      { key: 'meetingRequests', title: 'Meetings', href: paths.meetingRequests, icon: 'calendar-check' },
      { key: 'agentChat', title: 'Ask Guru', href: paths.agentChat, icon: 'sparkle', label: 'Beta' },
      { key: 'notifications', title: 'Notifications', href: paths.notifications, icon: 'bell' },
    ],
  },
  {
    key: 'admin',
    title: 'Admin & Tools',
    items: [
      {
        key: 'invoices',
        title: 'Invoices',
        icon: 'receipt',
        items: [
          { key: 'invoices:list', title: 'List invoices', href: paths.dashboard.invoices.list },
          { key: 'invoices:create', title: 'Create invoice', href: paths.dashboard.invoices.create },
          { key: 'invoices:settings', title: 'Invoice settings', href: paths.dashboard.invoices.settings },
          { key: 'invoices:details', title: 'Invoice details', href: paths.dashboard.invoices.details(':invoiceId'), disabled: true },
        ],
      },
      {
        key: 'billingThresholds',
        title: 'Billing Thresholds',
        icon: 'gauge',
        items: [
          { key: 'billing:fleet', title: 'Fleet view', href: paths.billingFleet },
          { key: 'billing:activity', title: 'Payment activity', href: paths.billingActivity },
        ],
      },
      { key: 'tasks', title: 'Tasks', href: paths.dashboard.tasks, icon: 'kanban' },
      { key: 'taskLogger', title: 'Task Activity', href: paths.taskLogger, icon: 'list-checks' },
      { key: 'knowledgeBase', title: 'Knowledge Base', href: paths.knowledgeBase, icon: 'book' },
      { key: 'agentMonitor', title: 'AI Chat Monitor', href: paths.agentMonitor, icon: 'gauge' },
      { key: 'developerApi', title: 'Developer API', href: paths.dashboard.settings.apiAccess, icon: 'code' },
    ],
  },
];

function filterNavItemsForUser(items = [], user, options = {}) {
  if (!user) {
    return [];
  }

  if (user.is_staff || user.is_superuser) {
    return items;
  }

  // Creative designers see only Creative Flights, Creative Knowledge (read-only), and Client Lanes (read-only).
  if (user.is_creative_designer) {
    return [
      {
        key: 'creative-designer-group',
        title: 'Creative',
        items: [
          {
            key: 'creativeTasks',
            title: 'Creative Flights',
            href: paths.creativeTasks,
            icon: 'airplane',
          },
          {
            key: 'creativeKnowledge',
            title: 'Creative Knowledge',
            href: paths.creativeKnowledge,
            icon: 'book',
          },
          {
            key: 'clientLanes',
            title: 'Client Lanes',
            href: paths.clientLanes,
            icon: 'table',
          },
          {
            key: 'designerCreativePerformance',
            title: 'Creative Performance',
            href: paths.dashboard.designerCreativePerformance,
            icon: 'table',
          },
        ],
      },
    ];
  }

  const normalizeSlug = (value = '') =>
    value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  const getMembershipDashboardSlug = (membership = {}) => {
    const clientSlug = membership?.client_slug || membership?.client_id;
    if (clientSlug) {
      return clientSlug;
    }
    const parentName = membership?.parent_company_name;
    if (parentName) {
      return normalizeSlug(parentName);
    }
    return membership?.parent_company_id || null;
  };

  const memberships = Array.isArray(user.client_memberships) ? user.client_memberships : [];
  const parentScopeClients = Array.isArray(options.parentScopeClients)
    ? options.parentScopeClients
    : [];
  if (memberships.length) {
    const defaultMembership = memberships[0];
    const clientSlug = getMembershipDashboardSlug(defaultMembership);
    const budgetCenterEnabled = true;
    const showZipCoverage = true;
    const budgetNeedsAttention = memberships.some((m) => m?.budget_needs_attention);
    const invoicesOutstandingCount = memberships.reduce(
      (sum, m) => sum + (parseInt(m?.invoices_outstanding_count, 10) || 0),
      0,
    );
    // Test-cohort gate: only clients opted into the new billing experience
    // see the Billing nav group. When on, invoices move into it (removed
    // from Account below) so all billing is consolidated in one place.
    const billingUiEnabled = memberships.some(
      (m) => m?.client_billing_ui_enabled,
    );
    // Beta rollout gate: only clients opted into Creative Performance
    // (ad_performance_enabled) see the page in their nav.
    const adPerformanceEnabled = memberships.some(
      (m) => m?.ad_performance_enabled,
    );
    const billingNavGroup = {
      key: 'client-billing-group',
      title: 'Billing',
      icon: 'gauge',
      items: [
        {
          key: 'client-my-billing',
          title: 'Billing',
          href: paths.myBilling,
          icon: 'gauge',
        },
        {
          key: 'client-my-billing-activity',
          title: 'Payment Activity',
          href: paths.myBillingActivity,
          icon: 'pulse',
        },
        {
          key: 'client-my-statements',
          title: 'Monthly Statements',
          href: paths.myStatements,
          icon: 'file',
        },
        {
          key: 'client-invoices',
          title: 'Invoices',
          href: paths.myInvoices.list,
          icon: 'receipt',
          ...(invoicesOutstandingCount > 0
            ? { label: `${invoicesOutstandingCount} Due` }
            : {}),
        },
      ],
    };
    const clientBudgetCenterHref = defaultMembership?.client_id
      ? `${paths.budgetCenter}?client_id=${defaultMembership.client_id}`
      : paths.budgetCenter;
    const clientLeadHref = defaultMembership?.client_id
      ? `${paths.leads.list}?client_id=${defaultMembership.client_id}`
      : null;
    const clientStatus = String(defaultMembership?.client_status || '').toLowerCase();
    const onboardingAllowed = ['new_business', 'onboarding'].includes(clientStatus);
    const isParentScopeMembership = !defaultMembership?.client_id && Boolean(
      defaultMembership?.parent_company_id || defaultMembership?.parent_company_name
    );

    // If we can't resolve a client identifier, fail closed and hide the menu.
    if (!clientSlug) {
      return [];
    }

    if (onboardingAllowed) {
      return [
        {
          key: 'client-onboarding-group',
          title: 'Onboarding',
          items: [
            {
              key: 'client-onboarding',
              title: 'Onboarding',
              href: paths.onboarding.forClient(clientSlug),
              icon: 'list-checks',
            },
            {
              key: 'client-webhook-setup',
              title: 'Lead Delivery Setup',
              href: paths.webhookSetup(clientSlug),
              icon: 'plugs-connected',
            },
          ],
        },
      ];
    }

    if (isParentScopeMembership) {
      const isFiveStarParent = defaultMembership?.parent_company_id === 1;
      const normalizedDefaultSlug = normalizeSlug(
        defaultMembership?.parent_company_name || ''
      );
      const sortedClients = [...parentScopeClients]
        .map((client = {}) => ({
          id: client.id,
          name: client.name || `Client ${client.id}`,
          slug: client.slug || normalizeSlug(client.name || String(client.id || '')),
          status: (client.status || '').toLowerCase(),
        }))
        .filter((client) => Boolean(client.slug))
        .filter((client) => normalizeSlug(client.slug) !== normalizedDefaultSlug)
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

      // Separate onboarding clients from active ones
      const onboardingClients = sortedClients.filter((c) => ['new_business', 'onboarding'].includes(c.status));
      const activeClients = sortedClients.filter((c) => !['new_business', 'onboarding'].includes(c.status));

      const clientLinks = activeClients.map((client) => ({
        key: `parent-client-dashboard-${client.id}`,
        title: client.name,
        href: paths.clientDashboard(client.slug),
      }));
      const onboardingLinks = onboardingClients.map((client) => ({
        key: `parent-client-onboarding-${client.id}`,
        title: client.name,
        href: `/onboarding/${client.slug}`,
        icon: 'list-checks',
        external: true,
      }));
      const parentClientNavItems = [...clientLinks];

      return [
        {
          key: 'client-dashboard-group',
          title: 'Overview',
          items: [
            {
              key: 'client-dashboard',
              title: 'Performance Dashboard',
              href: paths.clientDashboard(clientSlug),
              icon: 'chart-pie',
            },
            {
              key: 'client-schedule',
              title: 'Schedule a Meeting',
              href: paths.clientSchedule(clientSlug),
              icon: 'calendar-check',
            },
            ...(budgetCenterEnabled
              ? [
                  {
                    key: 'client-budget-center',
                    title: 'Budget Center',
                    href: clientBudgetCenterHref,
                    icon: 'table',
                    ...(budgetNeedsAttention ? { label: 'Action Needed' } : {}),
                  },
                ]
              : []),
            ...(showZipCoverage
              ? [
                  {
                    key: 'client-zip-coverage',
                    title: 'ZIP Coverage',
                    href: defaultMembership?.client_id
                      ? `/zip-coverage?client_id=${defaultMembership.client_id}`
                      : '/zip-coverage',
                    icon: 'map-pin',
                  },
                ]
              : []),
            // Parent-scope members have no single client_id, so they get the
            // unscoped leads list. The backend auto-scopes it to every child
            // client via limit_to_user_clients, so this shows all brand leads.
            {
              key: 'parent-leads',
              title: 'Leads',
              href: paths.leads.list,
              icon: 'user-focus',
            },
            {
              key: 'parent-ad-performance',
              title: 'Creative Performance',
              href: paths.dashboard.adPerformance,
              icon: 'image',
              label: 'Beta',
            },
            // Ask Guru keeps its own client dropdown (scoped to their child
            // clients); each chat is bound to the client they pick.
            {
              key: 'parent-ask-guru',
              title: 'Ask Guru',
              href: paths.agentChat,
              icon: 'sparkle',
              label: 'Beta',
            },
            ...(parentClientNavItems.length
              ? [
                  {
                    key: 'parent-client-dashboards',
                    title: 'Clients',
                    icon: 'users',
                    items: parentClientNavItems,
                  },
                ]
              : []),
            ...(isFiveStarParent
              ? [
                  {
                    key: 'parent-five-star-get-started',
                    title: 'New Branch',
                    href: '/get-started/five-star',
                    icon: 'share-network',
                    external: true,
                    label: 'Share',
                  },
                ]
              : []),
            ...onboardingLinks,
          ],
        },
        ...(billingUiEnabled ? [billingNavGroup] : []),
        {
          key: 'client-account-group',
          title: 'Account',
          items: [
            ...(billingUiEnabled
              ? []
              : [
                  {
                    key: 'client-invoices',
                    title: 'Invoices',
                    href: paths.myInvoices.list,
                    icon: 'receipt',
                    ...(invoicesOutstandingCount > 0
                      ? { label: `${invoicesOutstandingCount} Due` }
                      : {}),
                  },
                ]),
            {
              key: 'client-connections',
              title: 'Connections',
              icon: 'plugs-connected',
              items: [
                {
                  key: 'client-webhook-setup',
                  title: 'Lead Delivery',
                  href: isParentScopeMembership ? '/lead-delivery' : paths.webhookSetup(clientSlug),
                },
                {
                  key: 'client-data-integrations',
                  title: 'Data Integrations',
                  href: paths.dataIntegrations.root,
                },
              ],
            },
            {
              key: 'client-team',
              title: 'Team',
              href: paths.teamManagement,
              icon: 'users',
            },
            {
              key: 'client-api-access',
              title: 'Developer API',
              href: paths.dashboard.settings.apiAccess,
              icon: 'code',
            },
            {
              key: 'client-settings',
              title: 'Settings',
              href: paths.dashboard.settings.account,
              icon: 'gear-six',
            },
          ],
        },
      ];
    }

    // Five Star Bath Solutions clients (parent_company_id=1) get a simplified nav
    const isFiveStarClient = defaultMembership?.client_parent_company_id === 1;

    return [
      {
        key: 'client-dashboard-group',
        title: 'Overview',
        items: [
          {
            key: 'client-dashboard',
            title: 'Performance Dashboard',
            href: paths.clientDashboard(clientSlug),
            icon: 'chart-pie',
          },
          ...(!isFiveStarClient && budgetCenterEnabled
            ? [
                {
                  key: 'client-budget-center',
                  title: 'Budget Center',
                  href: clientBudgetCenterHref,
                  icon: 'table',
                  ...(budgetNeedsAttention ? { label: 'Action Needed' } : {}),
                },
              ]
            : []),
          ...(!isFiveStarClient && showZipCoverage
            ? [
                {
                  key: 'client-zip-coverage',
                  title: 'ZIP Coverage',
                  href: defaultMembership?.client_id
                    ? `/zip-coverage?client_id=${defaultMembership.client_id}`
                    : '/zip-coverage',
                  icon: 'map-pin',
                },
              ]
            : []),
          // Self-serve vertical expansion: 4-question intake that opens a
          // per-vertical onboarding flow for the team. Lives on the public
          // wizard route, hence external.
          ...(!isFiveStarClient
            ? [
                {
                  key: 'client-add-vertical',
                  title: 'Add a New Vertical',
                  href: `/onboarding/${clientSlug}/new-vertical`,
                  icon: 'plus-circle',
                  external: true,
                },
              ]
            : []),
          ...(adPerformanceEnabled
            ? [
                {
                  key: 'client-ad-performance',
                  title: 'Creative Performance',
                  href: paths.dashboard.adPerformance,
                  icon: 'image',
                  label: 'Beta',
                },
              ]
            : []),
          ...(clientLeadHref
            ? [
                {
                  key: 'client-leads',
                  title: 'Leads',
                  href: clientLeadHref,
                  icon: 'user-focus',
                },
              ]
            : []),
          // Ask Guru + Schedule a Meeting sit below Leads — secondary
          // surfaces clients can dip into after they've checked the
          // primary performance + targeting screens above.
          {
            key: 'client-ask-guru',
            title: 'Ask Guru',
            href: paths.agentChat,
            icon: 'sparkle',
            label: 'Beta',
          },
          ...(!isFiveStarClient
            ? [
                {
                  key: 'client-schedule',
                  title: 'Schedule a Meeting',
                  href: paths.clientSchedule(clientSlug),
                  icon: 'calendar-check',
                },
              ]
            : []),
        ],
      },
      ...(billingUiEnabled ? [billingNavGroup] : []),
      {
        key: 'client-account-group',
        title: 'Account',
        items: [
          ...(billingUiEnabled
            ? []
            : [
                {
                  key: 'client-invoices',
                  title: 'Invoices',
                  href: paths.myInvoices.list,
                  icon: 'receipt',
                },
              ]),
          ...(!isFiveStarClient
            ? [
                {
                  key: 'client-connections',
                  title: 'Connections',
                  icon: 'plugs-connected',
                  items: [
                    {
                      key: 'client-webhook-setup',
                      title: 'Lead Delivery',
                      href: paths.webhookSetup(clientSlug),
                    },
                    {
                      key: 'client-data-integrations',
                      title: 'Data Integrations',
                      href: paths.dataIntegrations.root,
                    },
                  ],
                },
              ]
            : []),
          ...(isFiveStarClient
            ? [
                {
                  key: 'client-email-notifications',
                  title: 'Email Notifications',
                  href: paths.emailNotifications,
                  icon: 'envelope-simple',
                },
              ]
            : []),
          {
            key: 'client-team',
            title: 'Team',
            href: paths.teamManagement,
            icon: 'users',
          },
          {
            key: 'client-api-access',
            title: 'Developer API',
            href: paths.dashboard.settings.apiAccess,
            icon: 'code',
          },
          {
            key: 'client-settings',
            title: 'Settings',
            href: paths.dashboard.settings.account,
            icon: 'gear-six',
          },
        ],
      },
    ];
  }

  // Client Inbox is deliberately absent: it is a staff surface. It exposes
  // AI triage, internal notes, owner routing and unsent reply drafts — on a
  // client member's own threads, but still our workings, not theirs.
  const allowedKeys = new Set([
    'clientList',
    'clientZips',
    'clientBudgets',
    'onboardingFlow',
    'knowledgeBase',
  ]);

  const filterItems = (list = []) =>
    list
      .map((item) => {
        const nextItems = item.items ? filterItems(item.items) : [];
        const keepSelf = allowedKeys.has(item.key);
        if (nextItems.length) {
          return { ...item, items: nextItems };
        }
        return keepSelf ? { ...item, items: undefined } : null;
      })
      .filter(Boolean);

  return items
    .map((group) => {
      const nextItems = filterItems(group.items || []);
      return { ...group, items: nextItems };
    })
    .filter((group) => group.items && group.items.length);
}

export default { navItems };
export { filterNavItemsForUser };
